import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { responseObj } from '../../nest-model/nest-model';


@Injectable()
export class PersonalSf6Provider {

  module: string = '';
  model: string = 'sf6s/personal';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello Personal SF6 Provider');
  }

  save(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "save";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType, (15 * 60) * 1000);
  }

  saveProfilePic(formData: { empId: string, namePicture: string }) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "saveProfilePic";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType, (15 * 60) * 1000);

  }

  delete(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType, (15 * 60) * 1000);
  }

  appReqDetail(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "appReqDetail";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  localField() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "localField";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/personal-sf6.ts